export const CURRENCY = {
  TW: "NT$",
};
